<div class="container">
  <header>
    <div class="logo" (click)="changeRoute('dashboard')">
      <img src="assets/images/accutrax-logo-white.png" alt="accutrax Logo" />
      <span class="version-number">Version 2.3.0-1</span>
    </div>
  </header>

  <div class="dynamic-content">
    <ng-container [ngSwitch]="true">
      <ng-container *ngSwitchCase="currentPath.includes('calendar')">
        <app-calendar-filters
          [currentPath]="currentPath"
        ></app-calendar-filters>
      </ng-container>
      <!-- <ng-container *ngSwitchCase="currentPath.includes('/admin/users')">
        <h2>Admin</h2>
      </ng-container> -->
    </ng-container>
    <app-counts *ngIf="roleService.getCurrentUserRole()"></app-counts>
  </div>

  <!-- <div class="footer">
    <button mat-button class="nav-button" (click)="logout()">Logout</button>
  </div> -->
</div>
